
import { IDialogProps } from "@digitallab/grid-common-components";
import { createContext } from "react";
export const DialogServiceContext = createContext<{
  show: ((props: IDialogProps) => Promise<unknown>) | (() => void);
}>({ show: () => {} });